const APP_KEY = 'pl:explorer';

export const clearState = () => {
  sessionStorage.removeItem(APP_KEY);
};

export const lintState = state => {
  // this is async to support a future state in which
  //  the server handles these checks.
  return new Promise(resolve => {
    const serializedState = JSON.stringify(state);
    // ensure the state does not go over the maximum
    //  allowed by sessionStorage

    const issues = [];
    if (serializedState.length >= 5242880) {
      issues.push({
        field: 'stateSize',
        message:
          'The current session cannot be saved because it exceeds our storage limits',
      });
    }
    resolve(issues);
  });
};

export const saveState = state => {
  sessionStorage.setItem(APP_KEY, JSON.stringify(state));
};

export const getState = () => {
  const storageData = sessionStorage.getItem(APP_KEY);
  if (!storageData) {
    return {};
  }
  return JSON.parse(storageData);
};

export const fetchState = () => {
  return new Promise(resolve => {
    resolve(getState());
  });
};

// this is how the session ID is set in the URL
export const setSessionId = id => {
  if (!id) {
    history.replaceState(null, '', '?');
  } else {
    history.replaceState(null, '', `?s=${id}`);
  }
};

export const getObjectValue = (object, key) => {
  const path = key.split('.');
  const lastKey = path.pop();
  let ptr = object;
  for (let i = 0, ii = path.length; i < ii; i++) {
    if (ptr[path[i]]) {
      ptr = ptr[path[i]];
    } else {
      return null;
    }
  }
  return ptr[lastKey];
};

/**
 * Transforms the "." delimited key from the schema into something
 *  that can be used as a prop name for a component.
 */
export const getPropName = key => {
  const path = key.split('.');
  const firstKey = path.shift();
  const keys = path.map(p => p.substring(0, 1).toUpperCase() + p.substring(1));
  return firstKey + keys.join('');
};
